<template>
  <i class="icon-bg" :style="styles">
    <feather :type="icon.type" :size="icon.size" :style="`color:` + icon.color + `;`" />
  </i>
</template>

<script>
export default {
	// eslint-disable-next-line vue/require-prop-types
	props: {
		icon: {
			type: Object,
			default: () => ({
				type: 'user',
				size: '18px',
				color: '#7159c1',
				width: '50px',
				height: '50px',
				borderRadius: '50%',
			})
		}
	},
	computed: {
		styles() {
			return {
				width: this.icon.width,
				height: this.icon.height,
				borderRadius: this.icon.borderRadius,
				backgroundColor: `${this.icon.color}31`,
			};
		}
	}
};
</script>

<style scoped>
.icon-bg {
  width: 50px;
  height: 50px;
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
</style>
